module.exports = __webpack_public_path__ + "static/media/sort-up-button.4cf5985f.svg";